import React, { CSSProperties, useEffect, useState } from 'react'

// Components
import Loading from '../Loading'

// Styles
import './styles.scss'

export default ({
  counter,
  title,
  onClick,
  disabled,
  style,
  isLoading,
}: {
  counter: number
  title: string
  onClick: () => void
  disabled: boolean
  style?: CSSProperties
  isLoading?: boolean
}) => {
  const [timer, setTimer] = useState<number>(0)

  useEffect(() => {
    if (counter > 0) {
      setTimer(counter)
    } else {
      setTimer(0)
    }
  }, [counter])

  useEffect(() => {
    if (timer <= 0) return
    const intervalId = setInterval(() => {
      setTimer(timer - 1)
    }, 1000)
    return () => clearInterval(intervalId)
  }, [timer])

  return (
    <button
      disabled={disabled || timer > 0 || isLoading}
      onClick={onClick}
      className={isLoading ? 'button-complete loading' : 'button-complete'}
      style={style}
    >
      {isLoading ? (
        <Loading
          color={'#FFF'}
          style={{ margin: '2px 0 0 0' }}
          width={70}
          height={70}
        />
      ) : (
        <span>
          {title} {timer > 0 ? `(${timer})` : ''}
        </span>
      )}
    </button>
  )
}
